import { 
  zlbCostControlBdStandardBindFeeItemPost,
  zlbCostControlBdStandardFormListPost,
  zlbCostControlBdStandardFormFeeItemListPost,
  zlbCostControlBdStandardCompositeDetailPost,
  zlbCostControlBdStandardSaveCompositePost,
  zlbCostControlBdFeeItemConfigSavePost,
  zlbCostControlBdFeeItemConfigChangeStatusPost,
  zlbCostControlBdFeeItemConfigDetailPost,
} from '@/api/zlbCostControl';
    
export default {
  namespace: 'FeeStandardManage',
  state: {},
  effects: {
    // 费用项规则绑定到机构/租户下
    * bindFeeItem ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdStandardBindFeeItemPost, payload);
      return res;
    },
    
    // 获取单据列表
    * getStandardFormList ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdStandardFormListPost, payload);
      return res;
    },
    // 单据费用项列表
    * getStandardFormItemList ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdStandardFormFeeItemListPost, payload);
      return res;
    },
    // 查询综合定额
    * fetchStandardCompositeDetail ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdStandardCompositeDetailPost, payload);
      return res;
    },
    // 保存综合定额
    * saveStandardComposite ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdStandardSaveCompositePost, payload);
      return res;
    },
    // 获取机构列表
    * getOrgList ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdStandardSaveCompositePost, payload);
      return res;
    },
    // 百搭费用规则详情
    * fetchFeeItemConfigDetail  ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdFeeItemConfigDetailPost, payload);
      return res;
    },
    // 百搭费用规则保存
    * saveFeeItemConfig  ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdFeeItemConfigSavePost, payload);
      return res;
    },
    // 费用项规则停启用
    * feeItemConfigChangeStatus  ({ payload }, { call }) {
      const res = yield call(zlbCostControlBdFeeItemConfigChangeStatusPost, payload);
      return res;
    },
  },
       
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
    